import { BaseFieldClass } from './baseField.class'

import { IHiddenField } from '@/types/serverField.type'
import { getValueFromObject } from '@/utils/getValueFromObject'

export class HiddenFieldClass extends BaseFieldClass {
  declare fieldValue: IHiddenField['Value']
  declare initialValue: IHiddenField['Value']

  constructor (field: IHiddenField) {
    super(field)
    const value = field.Value ?? field.DefaultValue
    this.initialValue = this.prepareValue(value)
    this.fieldValue = this.prepareValue(value)
  }

  prepareValue (value: IHiddenField['Value']): IHiddenField['Value'] {
    return value ?? ''
  }

  getValue () {
    return {
      [this.name]: this.fieldValue
    }
  }

  appendToFormData (formData: FormData): void {
    formData.append(this.name, String(getValueFromObject(this.fieldValue) ?? ''))
  }

  getFilterValue (): string {
    return String(getValueFromObject(this.fieldValue) ?? '')
  }
}
